module.exports = __webpack_public_path__ + "img/knowledge.f6236c25.svg";